<template>
  <!-- 标签栏目 -->
  <div class="tabs-bd">
    <el-scrollbar ref="scrollContainer" :native="true" :vertical="false" class="scroll-container tags-list">
      <div ref="tag" class="tag" v-for="(item, index) in tags" :key="index" :class="{ cur: $route.path === item.loadRes }">
        <div class="ub">
          <div class="name" @click="onTag(item)">{{ item.menuName }}</div>
          <div class="close">
            <i class="icon icon-close" v-if="index !== 0" @click="closeTag(item)"></i>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <div class="close-btn" @click="closeAllTag">
      <i class="icon icon-close"></i>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: 'tTags',
  data() {
    return {
      menu: {},
    };
  },
  props: {
    tags: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch: {
    $route(opt) {
      if (!opt.path.startsWith('/redirect')) {
        this.addTag();
        this.moveToTag();
      }
    },
  },
  created() {
    this.getMenu();
  },
  methods: {
    // 获取全部菜单列表
    getMenu: function () {
      this.$getJSON(apis.loginMenu).then((res) => {
        const menuResList = res.data;
        const menuMap = {};
        const menuNameMap = {};
        menuResList.forEach((item) => {
          menuMap[item.loadRes] = item;
          menuNameMap[item.loadRes] = item.menuName;
        });
        menuResList.forEach((item) => {
          let path = item.loadRes && item.loadRes.match(/\/\w*/g);
          if (path) {
            path = path.map((t, i, arr) => (i > 0 ? `${arr.slice(0, i).join('')}${t}` : t));
            item.pathName = path.map(t => ({ loadRes: t, title: menuNameMap[t] }));
          }
        });
        const menuObj = {};
        menuResList.forEach((item) => {
          menuObj[item.loadRes] = item.pathName;
        });
        this.$store.commit('MENUOBJ', menuObj);
        this.menu = menuMap;
        this.addTag(true);
      });
    },
    // 标签合并
    mergeTags: function (value) {
      const tags = this.tags;
      const index = tags.findIndex(t => t.loadRes === value.loadRes);
      if (index === -1) {
        tags.push(value);
      } else {
        tags.splice(index, 1, Object.assign(tags[index], value));
      }
      this.$store.commit('TAGS', tags);
    },
    // 新增标签
    addTag: function () {
      const menu = this.menu[this.$route.path] || { menuName: this.$t('components_tags.wei_zhi_cai_dan') };
      this.mergeTags({
        loadRes: this.$route.path,
        query: this.$route.query,
        appId: menu.appId,
        menuName: menu.menuName,
        keep: this.$route.meta.keep,
      });
    },
    // 选择标签
    onTag: function (item) {
      this.$emit('change', item);
      this.jump(item.loadRes, item.query);
    },
    // 关闭标签
    closeTag: function (tag) {
      // 删除当前标签同时切换到前一个标签页面
      const index = this.tags.findIndex(f => f.loadRes === tag.loadRes);
      this.tags.splice(index, 1);
      this.$store.commit('TAGS', this.tags);
      if (this.$route.path === tag.loadRes) {
        const newPath = this.tags[index - 1];
        this.$emit('change', newPath);
        this.jump(newPath.loadRes, newPath.query);
      }
      // 移除缓存
      if (tag.keep) {
        this.clearKeepAlive(tag.keep);
      }
    },
    // 关闭全部标签
    closeAllTag: function () {
      const curTags = this.tags.filter(t => this.$route.path === t.loadRes);
      this.$store.commit('TAGS', curTags);
    },
    // 移动标签
    moveToTag() {
      this.$nextTick(() => {
        const scrollWrapper = this.$refs.scrollContainer.$refs.wrap; // 滚动对象
        const scrollWidth = scrollWrapper.scrollWidth; // 滚动内容宽度
        const wrapWidth = this.$refs.scrollContainer.$el.offsetWidth; // 显示区域宽度
        // 未超出不处理
        if (wrapWidth === scrollWidth) {
          return;
        }
        const tagList = this.$refs.tag; // 标签列表
        const currentTag = tagList.find(t => t.className === 'tag cur'); // 当前标签（offsetLeft, offsetWidth）
        if (!currentTag) {
          return;
        }
        const leftWidth = currentTag.offsetLeft + currentTag.offsetWidth; // 偏移+宽度
        if (leftWidth < wrapWidth) {
          scrollWrapper.scrollLeft = 0;
        } else {
          scrollWrapper.scrollLeft = leftWidth - wrapWidth;
        }
      });
    },
  },
  mounted() {
  }
};
</script>

<style lang="scss">
.tabs-bd {
  border-bottom: 1px solid #e6ebf2;
  background-color: #ffffff;
  position: relative;
  padding-right: 30px;
  .close-btn {
    position: absolute;
    background-color: #ffffff;
    z-index: 5;
    right: 0;
    top: 0;
    width: 30px;
    height: 28px;
    border-left: 1px solid #f1f1f3;
    text-align: center;
    cursor: pointer;
    .icon {
      color: #e5e5e7;
      line-height: 29px;
    }
  }
  .tags-list {
    font-size: 0;
    height: 28px;
    background-color: #ffffff;
    // border-bottom: 1px solid #EEF2F8;
    .el-scrollbar__view {
      white-space: nowrap;
    }
    .el-scrollbar__wrap {
      overflow-x: auto;
      overflow-y: hidden;
      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    }
    .tag {
      display: inline-block;
      height: 28px;
      line-height: 28px;
      // padding-right: 15px;
      border-right: 1px solid #eef2f8;
      color: #666666;
      font-size: 12px;
      position: relative;
      cursor: pointer;
      &:nth-child(1) {
        .name {
          color: #6c757d;
        }
      }
      .name {
        color: #98a6ad;
        padding-left: 15px;
        padding-right: 5px;
      }
      .close {
        padding-left: 5px;
        padding-right: 10px;
        padding-top: 1px;
        font-size: 10px;
        color: rgba(0, 0, 0, 0.2);
        .icon {
          display: block;
          transform: scale(0.8);
        }
      }
      &.cur {
        background-color: #e4ebf2;
        border-bottom: 1px solid #e4ebf2;
        .name {
          color: #0d9ae0;
        }
        .icon {
          color: #415159;
        }
      }
    }
  }
}
</style>
